<template>
  <div class="critical-modal-overlay" @click="handleBackdropClick">
    <!-- Blurred background -->
    <div class="critical-backdrop"></div>
    
    <!-- Modal content -->
    <div class="critical-modal" @click.stop>
      <!-- Reminder Message -->
      <div class="reminder-message">
        <p v-if="isArabic">تذكير: هذا الطلب مضى عليه ساعة ولم يتم بدء التحضير</p>
        <p v-else>Erinnerung: Diese Bestellung ist eine Stunde alt und wurde noch nicht begonnen</p>
      </div>
      
      <!-- Use Existing OrderCard Component -->
      <div class="order-card-container">
        <OrderCard 
          :order="order"
          :isNew="true"
          :familyColor="null"
          class="critical-order-card"
          @action="handleCardAction"
          @viewDetails="handleViewDetails"
        />
      </div>
      
      <!-- Single OK Button -->
      <div class="ok-button-container">
        <button 
          @click="handleAcknowledge"
          class="btn-ok"
        >
          <span v-if="isArabic">فهمت</span>
          <span v-else>Verstanden</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import OrderCard from '@/components/OrderCard.vue';

export default {
  name: 'CriticalOrderModal',
  components: {
    OrderCard
  },
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState(['language']),
    
    isArabic() {
      return this.language === 'ar';
    }
  },
  methods: {
    handleCardAction(orderId, action) {
      if (action === 'prepare') {
        // Stop sound IMMEDIATELY in multiple ways
        this.stopSoundImmediately();
        this.$emit('stopSound');
        this.$emit('prepare', orderId);
        this.$emit('close');
      }
    },
    
    handleViewDetails() {
      // Don't allow viewing details in critical modal
      // Just shake to indicate it's not allowed
      this.shakeModal();
    },
    
    handleAcknowledge() {
      // Stop sound IMMEDIATELY in multiple ways
      this.stopSoundImmediately();
      this.$emit('stopSound');
      this.$emit('acknowledge', this.order.id);
      this.$emit('close');
    },
    
    stopSoundImmediately() {
      // Try to stop all possible audio playing
      const allAudio = document.querySelectorAll('audio');
      allAudio.forEach(audio => {
        audio.pause();
        audio.currentTime = 0;
        audio.volume = 0;
      });
      
      // Also try to stop any Audio objects created with new Audio()
      window.speechSynthesis?.cancel(); // Stop any speech synthesis
      
      console.log('🚨 EMERGENCY STOP: All audio stopped immediately');
    },
    
    handleBackdropClick() {
      // Prevent closing on backdrop click - force user to choose an action
      // Could add a shake animation here to indicate they must choose
      this.shakeModal();
    },
    
    shakeModal() {
      const modal = this.$el.querySelector('.critical-modal');
      modal.classList.add('shake-animation');
      setTimeout(() => {
        modal.classList.remove('shake-animation');
      }, 500);
    }
  },
  mounted() {
    // Play critical sound when modal opens
    this.$emit('playSound');
    
    // Prevent body scroll
    document.body.style.overflow = 'hidden';
  },
  
  beforeDestroy() {
    // Restore body scroll
    document.body.style.overflow = '';
  }
};
</script>

<style scoped>
.critical-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.3s ease-out;
}

.critical-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: none;
}

.critical-modal {
  position: relative;
  background: var(--ods-surface);
  border: 2px solid #EF4444;
  border-radius: var(--ods-radius);
  padding: 30px;
  max-width: 600px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 0 20px rgba(239, 68, 68, 0.3);
  animation: slideIn 0.3s ease-out;
}

.reminder-message {
  text-align: center;
  margin-bottom: 25px;
}

.reminder-message p {
  color: #EF4444;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  font-family: inherit;
}

.order-card-container {
  margin: 20px 0;
  display: flex;
  justify-content: center;
}

.critical-order-card {
  max-width: 400px;
  width: 100%;
  border: 2px solid #EF4444 !important;
  box-shadow: 0 0 20px rgba(239, 68, 68, 0.4) !important;
}


.ok-button-container {
  display: flex;
  justify-content: center;
  margin-top: 25px;
}

.btn-ok {
  padding: 15px 40px;
  border: none;
  border-radius: var(--ods-radius);
  font-weight: bold;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.2s;
  background: linear-gradient(135deg, var(--ods-accent), var(--ods-accent));
  color: var(--ods-ink);
  min-width: 120px;
  font-family: inherit;
}

.btn-ok:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 15px rgba(96, 165, 250, 0.4);
}


/* Animations */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideIn {
  from {
    transform: translateY(-50px) scale(0.9);
    opacity: 0;
  }
  to {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}


.shake-animation {
  animation: shake 0.5s ease-in-out;
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  10%, 30%, 50%, 70% { transform: translateX(-10px); }
  20%, 40%, 60%, 80% { transform: translateX(10px); }
}
</style>